import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Subscription, take } from 'rxjs';
import { StartUpConfigUiService } from '../../../shared/service/ui/start-up-config-ui.service';
import { QuoteEmailLandingService } from '../../services/quote-email-landing.service';
import { GtmDatalayerUiService } from '../../../shared/service/ui/gtm-datalayer-ui.service';

@Component({
  selector: 'app-quote-email-landing',
  templateUrl: './quote-email-landing.component.html'
})
export class QuoteEmailLandingComponent implements OnInit, OnDestroy {
  private subscription: Subscription;
  private isProcessingLandingCalled = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private landingService: QuoteEmailLandingService,
    private startUpConfigUiService: StartUpConfigUiService,
    private gtmDatalayerUIService: GtmDatalayerUiService
  ) {}

  public ngOnInit(): void {
    this.gtmDatalayerUIService.initGtmDatalayer(this.startUpConfigUiService.sessionInfo$, false).subscribe();
    const routerSub = this.router.events.subscribe({
      next: (navigationEvent) => {
        if (navigationEvent instanceof NavigationEnd) {
          if (routerSub) {
            routerSub.unsubscribe();
          }
          this.processLanding();
        }
      }
    });

    const cSig = this.route.snapshot.queryParamMap.get('c-sig');
    if (!cSig) {
      // Redirect to quote landing with the client signature
      this.landingService
        .getGeneratedSignature()
        .pipe(take(1))
        .subscribe({
          next: (clientSignature) => {
            this.router.navigate(['/email-landing/quote'], {
              queryParamsHandling: 'merge',
              queryParams: {
                'c-sig': clientSignature
              }
            });
          }
        });
    } else {
      this.processLanding();
    }
  }

  public ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  private performRedirection(data: any): void {
    if (data.source?.includes('modifica-tus-datos')) {
      this.router.navigate([data.source]);
    } else {
      setTimeout(() => {
        this.router.navigate(['/progress'], {
          queryParamsHandling: 'merge',
          queryParams: {
            waitpagetype: `${data.source}?key=${data.customerActivityGuid}&actid=${data.ecaid}`
          }
        });
      }, 3000);
    }
  }

  private handleRedirection(): void {
    this.startUpConfigUiService.cmsUrl$.pipe(take(1)).subscribe({
      next: (cmsUrl) => {
        if (cmsUrl) {
          location.href = cmsUrl;
        }
      }
    });
  }

  private processLanding(): void {
    // Ensure Process landing runs only once
    if (this.isProcessingLandingCalled) {
      return;
    }

    this.subscription = this.landingService.processLanding().subscribe({
      next: (data) => {
        if (data && data.isSuccess) {
          this.performRedirection(data);
        } else {
          this.handleRedirection();
        }
      },
      error: () => {
        this.handleRedirection();
      }
    });
    this.isProcessingLandingCalled = true;
  }
}
